import { useEffect, useState } from "react";
import { Grid, TextField, Container, Typography, Box } from "@mui/material";
import Secao from "../../../util/ui/secao";
import MoedaInput from "../../../util/ui/inputs/moedaInput";
import moment, { Moment } from "moment";
import { useUsuario } from "../../../../providers/usuarioProvider";
import { IconArrowDownCircle } from "@tabler/icons-react";
import Functions from "../../../../callable/functions";
import ImpostoInternacional, {
  AbatimentoInternacional,
} from "../../../../models/impostoInternacional";
import { onSnapshot } from "firebase/firestore";
import ImpostoInternacionalDb from "../../../../db/impostoInternacionalDb";
import { LoadingButton } from "@mui/lab";

type Props = {
  dataBase: Moment;
};

export default function AbatimentosInternacional({ dataBase }: Props) {
  const { visualizado } = useUsuario();
  const [abatimento, setAbatimento] = useState<AbatimentoInternacional>({
    prejuizo: 0,
  });
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    if (!!visualizado)
      return onSnapshot(
        new ImpostoInternacionalDb().doc({
          usuarioId: visualizado,
          impostoId: dataBase.format("YYYY-MM"),
        }),
        (snapshot) => {
          if (snapshot.exists()) {
            const pontoDePartida = snapshot.data()!;
            setAbatimento(pontoDePartida.abatimento);
          }
        }
      );
  }, [dataBase, visualizado]);

  const salvar = async () => {
    setSalvando(true);
    return new Functions()
      .pontoDePartidaInternacional({
        pontoDePartida: new ImpostoInternacional({
          criadoEm: moment(),
          dataBase: dataBase.clone().endOf("month"),
          resultado: {
            ganhoCapital: 0,
            rendimentos: 0,
            resultadoTotal: 0,
          },
          abatimentoAnterior: { prejuizo: 0 },
          abatimento: abatimento,
          impostoMensal: 0,
          impostoAnualDevido: 0,
        }).toJSON(),
      })
      .finally(() => setSalvando(false));
  };

  return (
    <Container fixed disableGutters sx={{ py: 1 }}>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        paddingBottom={2}
      >
        <Typography variant="h3" color="text.primary">
          Prejuizo acumulado ate{" "}
          <Typography
            component="span"
            variant="dataMono"
            sx={{ fontSize: "inherit", fontWeight: 500 }}
          >
            {dataBase.clone().endOf("month").format("DD/MM/YYYY")}
          </Typography>
        </Typography>
        <Box paddingX={1} />
        <LoadingButton
          variant="contained"
          size="small"
          color="success"
          onClick={salvar}
          loadingPosition="start"
          startIcon={<IconArrowDownCircle />}
          loading={salvando}
        >
          Salvar
        </LoadingButton>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Secao titulo="Prejuizo Internacional">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TextField
                  id="standard-intl-prejuizo"
                  label="Prejuizo acumulado"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={abatimento.prejuizo}
                  onChange={(e) => {
                    const floatValue: number = (e.target as any).floatValue;
                    setAbatimento({ prejuizo: floatValue });
                  }}
                  InputProps={{
                    inputComponent: MoedaInput,
                  }}
                />
              </Grid>
            </Grid>
          </Secao>
        </Grid>
      </Grid>
    </Container>
  );
}
